const NucleinOrder = () => import('@pages/nuclein/NucleinOrder')
const NucleinRemind = () => import('@pages/nuclein/NucleinRemind')
const PatientNuclein = () => import('@pages/nuclein/PatientNuclein')
const NucleinPDF = () => import('@pages/nuclein/NucleinPDF')

export const nuclein = [
  {
    path: '/nuclein/NucleinOrder',
    name: 'NucleinOrder',
    component: NucleinOrder,
    meta: {}
  },
  {
    path: '/nuclein/NucleinRemind',
    name: 'NucleinRemind',
    component: NucleinRemind,
    meta: {}
  },
  {
    path: '/nuclein/PatientNuclein',
    name: 'PatientNuclein',
    component: PatientNuclein,
    meta: {}
  },
  {
    path: '/nuclein/NucleinPDF',
    name: 'NucleinPDF',
    component: NucleinPDF,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/nuclein.route.js